import BaseModel from "../BaseModel";
import Address from "./Address";
import Contact from "./Contact";
import Contract from "./Contract";
import CustomerType from "./CustomerType";
import Environment from "./Environment";
import Imperative from "./Imperative";
import License from "./License";
import Name from "./Name";
import Note from "./Note";
import Sample from "./Sample";
import Billings from "./Billing";
export default class Customer extends BaseModel{
    static entity = 'customers';
    static fields(){
        return {
            id: this.attr(null),
            uuid: this.attr(null),
            hubspot_company_id: this.attr(null),
            customer_type_id: this.attr(null),
            user_id: this.attr(null),
            addresses: this.hasMany(Address, 'customer_id'),
            contacts: this.hasMany(Contact, 'customer_id'),
            imperatives: this.hasMany(Imperative, 'customer_id'),
            licenses: this.hasMany(License, 'customer_id'),
            names: this.hasMany(Name, 'customer_id'),
            notes: this.hasMany(Note, 'customer_id'),
            customer_type: this.belongsTo(CustomerType, 'customer_type_id'),
            contract: this.attr(null),
            environment: this.hasOne(Environment, 'customer_id'),
            deleted_at: this.attr(null),
            primary_name: this.attr(null),
            samples: this.hasMany(Sample, 'customer_id'),
            billing: this.hasOne(Billings, "customer_id")
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'addresses', 'contacts', 'imperatives', 'licenses', 'names', 'notes', 'customer_type', 'contract', 'environment', 'deleted_at', 'primary_name', 'samples', 'billing']
    }
    static route(){
        return '/customers'
    }
}
